import React from "react";
import PropTypes from "prop-types";
import SuiInput from "components/SuiInput";
import EditableField from "./editableField";

const ProfessionalCardField = ({
  value,
  isEditing,
  onEdit,
  onSave,
  onCancel,
  onChange,
  isVisible,
}) => {
  if (!isVisible) return null;

  return (
    <EditableField
      label="Tarjeta Profesional"
      value={value}
      isEditing={isEditing}
      onEdit={onEdit}
      onSave={onSave}
      onCancel={onCancel}
    >
      <SuiInput
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Tarjeta Profesional"
        fullWidth
      />
    </EditableField>
  );
};

ProfessionalCardField.propTypes = {
  value: PropTypes.string,
  isEditing: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
};

export default ProfessionalCardField;
